import { Component, Input } from '@angular/core';
import { ReferenceDataConstants } from '../../../../../lib/constants/reference-data-constants';
import { DeclarationPageContentDto } from '../../../models/declaration-page-content-dto';
import { BaseMortgageApplicationComponent } from '../../../pages/base-mortgage-application.component';
import { MortgageApplicationStore } from '../../../services/mortgage-application-store';

@Component({
  selector: 'boi-marketing-declaration-content',
  templateUrl: './marketing-declaration-content.component.html',
  styleUrls: ['./marketing-declaration-content.component.scss']
})
export class MarketingDeclarationContentComponent extends BaseMortgageApplicationComponent {
  @Input() public declarationDto: DeclarationPageContentDto;
  referenceDataConstants = ReferenceDataConstants;

  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }
}
